// src/App.js
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/theme';
import Layout from './components/Layout/Layout';
import AppRoutes from './routes';
import { AuthProvider } from './context/AuthContext';
import { useLocation } from 'react-router-dom';

// Create a wrapper component to conditionally render Layout
const LayoutWrapper = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  // Don't wrap admin routes with the main layout
  if (isAdminRoute) {
    return children;
  }

  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AuthProvider>
          <LayoutWrapper>
            <AppRoutes />
          </LayoutWrapper>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;